import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerLicense } from '@syncfusion/ej2-base';

if (environment.production) {
  enableProdMode();
}
registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF1cXmhPYVFyWmFZfVhgdl9DZ1ZURmYuP1ZhSXxVdkBhXH9cdXNQQWFaWEF9XEE=');

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    // Check if the browser supports service workers and necessary Firebase features
    if ('serviceWorker' in navigator && 
        'Notification' in window &&
        'serviceWorker' in navigator &&
        'PushManager' in window) {
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
          //console.log('Service Worker registration successful with scope:', registration.scope);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    } else {
      //console.log('Firebase messaging is not supported in this browser');
    }
  })
  .catch(err => console.error(err));